import type { AnalyticsFilters } from "../state";

export const renderPlotHeader = ({
    svg,
    plotTitle,
    filters,
}: {
    svg: any;
    plotTitle: string;
    filters: AnalyticsFilters;
}): void => {
    // Add plot title
    svg.append("text")
        .attr("x", 10)
        .attr("y", 25)
        .attr("fill", "black")
        .attr("font-size", "16px")
        .text(plotTitle);

    // Build filter text array for non-default filters
    const filterTexts: string[] = [];

    // Add provider filter if set
    if (
        filters.providers &&
        filters.providers !== "all" &&
        Array.isArray(filters.providers) &&
        filters.providers.length > 0
    ) {
        const count = filters.providers.length;
        filterTexts.push(count === 1 ? "1 provider" : `${count} providers`);
    }

    // Add detection limit (always show)
    if (filters.detectionLimit) {
        filterTexts.push(`≥ ${filters.detectionLimit} kg/h`);
    }

    // Add location preset filter if set
    if (filters.locationPreset && filters.locationPreset.length > 0) {
        filterTexts.push("Filtering by area");
    }

    // Add site type filter if set
    if (filters.siteType && filters.siteType.length > 0) {
        const count = filters.siteType.length;
        filterTexts.push(count === 1 ? "1 site type" : `${count} site types`);
    }

    // Build complete filter text
    const dateRangeText = `Date range: ${filters.quarterFrom.replace("-", " ").toUpperCase()} - ${filters.quarterTo.replace("-", " ").toUpperCase()}`;
    const additionalFilters =
        filterTexts.length > 0 ? ` | ${filterTexts.join(" | ")}` : "";
    const completeFilterText = dateRangeText + additionalFilters;

    // Add filters
    svg.append("text")
        .attr("x", 10)
        .attr("y", 45)
        .attr("fill", "#888")
        .attr("font-size", "13px")
        .text(completeFilterText);
};
